/* eslint-disable no-underscore-dangle */

// eslint-disable-next-line no-var
var Component = class Component {
  constructor($element, $location, $timeout) {
    this._$element = $element;
    this._$location = $location;
    this._$timeout = $timeout;
  }

  $postLink() {
    this.setIcon();
  }

  $onChanges() {
    this.setIcon();
  }

  setIcon() {
    if (this.component && this.component.icon) {
      this._$timeout(() => {
        const icon = `<svg xmlns="http://www.w3.org/2000/svg"><use xmlns:xlink="http://www.w3.org/1999/xlink" href="#icons-sprite_${this.component.icon}"></use></svg>`;
        const $iconContainer = this._$element.find('.component-icon');
        $iconContainer.html(icon);
      }, 100);
    }
  }
};

xplenty.component('component', {
  controller: ['$element', '$location', '$timeout', Component],
  // eslint-disable-next-line global-require
  template: require('../../../views/directives/component.html'),
  bindings: {
    component: '<',
  },
});
